import * as React from 'react';
import Stack from '@mui/material/Stack';
import RestrictedAccess from '../../components/RestrictedAccess';
import catalogApiClient from '../../services/catalogapi';
import { AxiosResponse } from 'axios';
import { alertError } from '../../slices/global/alertSlice';
import { useAppDispatch } from '../../hooks';
import { Button, Divider, TextField } from '@mui/material';
import { AmazonListing } from './amazonModel';
import { EbayListing } from './ebayModel';
import AmazonListingDisplay from './AmazonListing';
import { EbayListingDetails } from './ebayListingDetailModel';
import EbayListingDisplay from './EbayListing';

export default function ListingData() {
  const [sku, setSku] = React.useState<string>('');
  const [amazonUsListing, setAmazonUsListing] = React.useState<AmazonListing | null>(null);
  const [amazonCaListing, setAmazonCaListing] = React.useState<AmazonListing | null>(null);
  const [ebayUsListing, setEbayUsListing] = React.useState<EbayListing | null>(null);
  const [ebayCaListing, setEbayCaListing] = React.useState<EbayListing | null>(null);
  const [ebayListingDetail, setEbayListingDetail] = React.useState<EbayListingDetails | null>(null);
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    if (!sku) {
      return;
    }
    const controller = new AbortController();

    (async () => {
      await catalogApiClient
        .get(`api/v1/Amazon/bySku/${sku}`, {
          signal: controller.signal,
        })
        .then((response: AxiosResponse<AmazonListing[]>) => {
          if (response.data) {
            setAmazonUsListing(response.data.find((x) => x.countryId === 1) ?? null);
            setAmazonCaListing(response.data.find((x) => x.countryId === 2) ?? null);
          }
        })
        .catch(function (err) {
          if (err.message !== 'canceled') {
            dispatch(alertError(`Failed to retrieve data for amazon. Reason: ${err}`));
          }
        });
      await catalogApiClient
        .get(`api/v1/Ebay/${sku}`, {
          signal: controller.signal,
        })
        .then((response: AxiosResponse<EbayListing>) => {
          if (response.data) {
            setEbayUsListing(response.data);
            setEbayCaListing(response.data);
            catalogApiClient
              .get(`api/v1/Ebay/ById/${response.data.ebayItems[0].id}`)
              .then((detailResponse: AxiosResponse<EbayListingDetails>) => {
                setEbayListingDetail(detailResponse.data);
              });
          }
        })
        .catch(function (err) {
          if (err.message !== 'canceled') {
            dispatch(alertError(`Failed to retrieve data for ebay. Reason: ${err}`));
          }
        });
    })();
  };

  return (
    <RestrictedAccess type="UI-Access" value="Generate Fitment">
      <Stack spacing={2}>
        <TextField
          id="sku"
          value={sku}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSku(event.target.value);
          }}
          label="Sku"
        />
        <Button color="success" variant="contained" onClick={handleSubmit}>
          Search
        </Button>
        <Divider />
        <AmazonListingDisplay value={amazonUsListing} currency="USD" />
        <AmazonListingDisplay value={amazonCaListing} currency="CAD" />
        <EbayListingDisplay
          value={ebayUsListing}
          valueDetail={ebayListingDetail}
          country="US"
          sellerId={1}
        />
        <EbayListingDisplay
          value={ebayCaListing}
          valueDetail={ebayListingDetail}
          country="CA"
          sellerId={2}
        />
      </Stack>
    </RestrictedAccess>
  );
}
